var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.137 3.945a2.1 2.1 0 0 1-1.04-1.82v-.003C14.097.95 13.158 0 12 0S9.903.95 9.903 2.122v.003a2.1 2.1 0 0 1-1.041 1.82C4.195 6.657 6.877 15.66 2 17.251V19h20v-1.749c-4.877-1.591-2.195-10.594-6.863-13.306M8.409 16H6.527c1.245-2.741.879-9.012 3.873-10.655C8.639 7.412 9.45 12.849 8.409 16M12 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2M9 21h6c0 1.598-1.393 3-2.971 3S9 22.598 9 21"
  })));
};
export default SvgBell;